import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';

var COMMON_PREFIX = '@defign';
var NF_SERVICE_TYPE = {
  MY_ASSET: 'myAsset',
  PAYMENT: 'payment',
  FINANCE: 'finance',
  STOCK: 'stock',
  REAL_ESTATE: 'realEstate'
};
var NF_SERVICE_INFO = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, NF_SERVICE_TYPE.MY_ASSET, {
  text: '내 자산',
  href: '/mydata/home'
}), NF_SERVICE_TYPE.PAYMENT, {
  text: '결제',
  href: '/historybenefit/home'
}), NF_SERVICE_TYPE.FINANCE, {
  text: '금융',
  href: '/finance'
}), NF_SERVICE_TYPE.STOCK, {
  text: '증권',
  href: '/'
}), NF_SERVICE_TYPE.REAL_ESTATE, {
  text: '부동산',
  href: '/'
});
var BADGE_TYPE = {
  DOT: 'dot',
  NEW: 'new'
};
var RESPONSIVE = {
  MOBILE: 320,
  TABLET: 600,
  DESKTOP: 1152
};

export { BADGE_TYPE, COMMON_PREFIX, NF_SERVICE_INFO, NF_SERVICE_TYPE, RESPONSIVE };
